export default{
  all (context) {
    var params = {
      page: context.page
    }

    context.loading = true
    context.$http.get('product_offers', {params: params}).then(response => {
      context.loading = false
      context.offers = response.body.data
      context.pagination = response.body.metadata.pagination
    })
  },
  get (context, id) {
    context.$http.get('product_offers/' + id).then(response => {
      context.offer = response.body.data[0]
    })
  },
  search (context, uid, term, catalog) {
    var params = {
      uid: uid,
      term: term,
      catalog: catalog
    }

    var options = {
      before (request) {
        if (context.previousRequest) {
          context.previousRequest.abort()
        }
        context.previousRequest = request
      }
    }

    return context.$http.post('product_offers/search', params, options)
  },
  purchase (context, identifier, saleOptionID) {
    var params = {
      identifier: identifier,
      sale_option_id: saleOptionID
    }
    return context.$http.post('product_offers/purchase', params)
  }
}



// WEBPACK FOOTER //
// ./src/services/productOffers.js